import httpService from '@/core/http-service'

const state = {
  users: null,
  currentUser: null
}

const mutations = {
  set_users(state, payload) {
    state.users = payload
  },
  set_current_user(state, payload) {
    state.currentUser = payload
  }
}

const actions = {
  async getUsers({ commit }, payload) {
    const response = await httpService.get('auth/myusers')
    commit('set_users', response.data.users)
  },
  setCurrentUser({ commit }, payload) {
    commit('set_current_user', payload)
  },
  async updateUser({ commit }, payload) {
    const response = await httpService.post('auth/myusers/update', payload)
    commit('set_users', response.data.users)
  },
  async deleteUser({ commit }, payload) {
    const response = await httpService.post('auth/myusers/delete', payload)
    commit('set_users', response.data.users)
  },
  async undeleteUser({ commit }, payload) {
    const response = await httpService.post('auth/myusers/undelete', payload)
    commit('set_users', response.data.users)
  }
}

const getters = {
  users: state => state.users,
  currentUser: state => state.currentUser
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
